import "../../index32.css";
import { jsx as t, jsxs as d, Fragment as y } from "react/jsx-runtime";
import { useState as N, useRef as a, useEffect as g } from "react";
import { AlertLineIcon as E } from "@ifrc-go/icons";
import { i as c } from "../../core-DVmjA3_O.js";
import { _ as R } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import h from "../InlineLayout/index.js";
import x from "../Popup/index.js";
const C = "_error-content_ny31g_1", I = "_input-error_ny31g_5", P = "_pointer_ny31g_16", r = {
  errorContent: C,
  inputError: I,
  pointer: P
};
function k(m) {
  const {
    children: n,
    className: p,
    disabled: f,
    floating: u
  } = m, [l, _] = N(!1), o = a(), e = a(null);
  g(
    () => {
      if (c(e.current))
        return;
      const {
        current: {
          parentElement: i
        }
      } = e;
      c(i) || (o.current = i, _(!0));
    },
    []
  );
  const s = /* @__PURE__ */ t(
    h,
    {
      className: r.errorContent,
      before: /* @__PURE__ */ t(E, { className: r.icon }),
      spacing: "xs",
      children: n
    }
  );
  return u ? /* @__PURE__ */ d(y, { children: [
    !l && /* @__PURE__ */ t(
      "div",
      {
        className: r.tooltipDummy,
        ref: e
      }
    ),
    n && !f && /* @__PURE__ */ t(
      x,
      {
        className: R(r.inputError, p),
        pointerClassName: r.pointer,
        parentRef: o,
        children: s
      }
    )
  ] }) : s;
}
export {
  k as default
};
